<template>
	<li class="my-bookmark__tag-list__item" @click="select">
		<a href="javascript:" role="button" :class="['my-bookmark__tag-list__link', '#bookmark_tag', isSelected ? 'my-bookmark__tag-list__link--selected' : '']">
			<span>{{tag.tagString}}</span>
			<span v-if="isSelected" class="ico-checked">
				<span class="sr_only">선택됨</span>
			</span>
		</a>
	</li>
</template>

<script>
	export default {
		props: ['tag', 'focused'],
		computed: {
			isSelected: function () {
				return this.tag.id === this.focused ? 'on' : '';
			}
		},

		methods: {
			select: function () {
				this.$emit('tag-select', this.tag.id);
			}
		}
	}
</script>
